import { AnimationController } from '@ionic/angular';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigModalAnimation {

  constructor(public animationCtrl: AnimationController) { }

  getAnimations() {
    const  enterAnimation =  (baseEl: any) => {
      const root = baseEl.shadowRoot;

      const backdropAnimation = this.animationCtrl.create()
        .addElement(root.querySelector('ion-backdrop')!)
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = this.animationCtrl.create()
        .addElement(root.querySelector('.modal-wrapper')!)
        .fromTo('transform', 'translate3d(100%, 0,  0)', 'translate3d(0,0,0')

      return this.animationCtrl.create()
        .addElement(baseEl)
        .easing('ease-out')
        .duration(500)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };

    const  leaveAnimation = (baseEl: any) => {
      return enterAnimation(baseEl).direction('reverse');
    }
    
    return {
      enterAnimation,
      leaveAnimation
    };
  }
}
